import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M3.41675 14.5836V5.41699H16.5914V14.5836H3.41675ZM4.50006 13.5003H7.44721V6.50031H4.50006V13.5003ZM8.5305 13.5003H11.4776V6.50031H8.5305V13.5003ZM12.5609 13.5003H15.5081V6.50031H12.5609V13.5003Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map